module.exports = __webpack_public_path__ + "static/img/dialog-bg-2.7d080682.png";